// extracted by mini-css-extract-plugin
export default {"input":"select_input__s418e"};